import { render, staticRenderFns } from "./ExternalHeader.vue?vue&type=template&id=77986362&"
import script from "./ExternalHeader.vue?vue&type=script&lang=js&"
export * from "./ExternalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExternalHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports